module.exports = __webpack_public_path__ + "ty3-a8421699.png";